<template>
  <div>
    <mheader></mheader>
    <div style="margin-top: 3rem;">
      <p>{{$t('i.index_welcome')}}</p>
      <p>{{$t('i.index_introduce')}}</p>
      <!-- <p>HTML/CSS/JavaScript/Vue/React/Node.js/mongoDB</p> -->
      <p>
        <router-link to="/article">[Article List]</router-link>
      </p>
      <p>Thanks for your attention.</p>
      <!-- <p>{{$t('i.index_contact')}}:</p>
      <p>{{$t('i.index_contact_phone')}}&nbsp;&nbsp;KzEgKDIwMSkgMjk3IDUzMjY=</p> -->
    </div>
    <!-- <article-category></article-category> -->
    <mfooter></mfooter>
  </div>
</template>

<script>
// import axios from '@/api';
import Mheader from '@/components/Mheader';
import Mfooter from '@/components/Mfooter';
// import ArticleListComp from '@/components/ArticleListComp';
// import ArticleCategory from '@/components/ArticleCategory';

export default {
  name: 'Home',
  components: {
    Mheader,
    Mfooter,
    // ArticleListComp,
    // ArticleCategory
  },
  data () {
    return {
    }
  }
}
</script>

<style scoped>

p {
  height: 1rem;
  line-height: 1.5rem;
  text-align: left;
  color: #999;
  font-size: 1rem;
}
</style>
<style>
img {
  max-width: 100%!important;
}
</style>
